import React, {PureComponent} from "react"
import styled from "styled-components"
import {chunk} from "lodash"

import {connect} from "@irati/store"
import {TextButton} from "@irati/ui/src/Button"
import {threePxElevation} from "@irati/ui/src/global/elevation"
import {ReduxState} from "@irati/store/types"
import {Inspiration} from "@irati/types"
import {Hr, Row, Col} from "@irati/ui/src/Layout"
import {Label} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import authentication from "@irati/auth"

import {InspirationTile} from "."

const StyledHr = styled(Hr)`
  margin-top: 0px;
`

const StyledCol = styled(Col)`
  margin-bottom: ${({theme}) => theme.spacing.four};
`

const StyledTextButton = styled(TextButton)`
  transition:
    transform 0.24s,
    box-shadow 0.24s;
  :hover {
    ${threePxElevation};
    border: none;
    cursor: pointer;
    transform: translateY(-4px);
  }
`

interface Props {
  className?: string
  inspirations: Inspiration[]
  isMobile: boolean
  onClick(value: Inspiration): void
}

class InspirationTiles extends PureComponent<Props> {
  static defaultProps = {
    className: null
  }

  renderList = (inspirations: Inspiration[]) => {
    const {isMobile, onClick} = this.props
    const chunkSize = isMobile ? 1 : 2

    return chunk(inspirations, chunkSize).map((sub, i) => (
      <Row key={i}>
        <>
          {sub.map((inspiration) => (
            <StyledCol key={inspiration.id} xs={12} sm={6}>
              <InspirationTile inspiration={inspiration} onClick={onClick} StyledTextButton={StyledTextButton} id={inspiration.id} />
            </StyledCol>
          ))}
        </>
      </Row>
    ))
  }

  render() {
    const tenant = authentication.userTenant()
    const {inspirations} = this.props
    const companyValues = inspirations.filter((i) => i.isCompanyValue)
    const defaultInspirations = inspirations.filter((i) => !i.isCompanyValue)
    const hasCompanyValues = !!companyValues.length

    return (
      <>
        {hasCompanyValues && (
          <>
            <Label uppercase>
              <FormattedMessage id="recognition.popup.createPoll.inspire.values" values={{tenantName: tenant.public_name}} />
            </Label>
            {this.renderList(companyValues)}
            <StyledHr />
          </>
        )}
        <>
          <Label uppercase>
            <FormattedMessage id="recognition.popup.createPoll.inspire.suggested" />
          </Label>
          {this.renderList(defaultInspirations)}
        </>
      </>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => {
  return {
    isMobile: mq.lessThan.sm
  }
}

export default connect(mapStateToProps)(InspirationTiles)
